import { useEffect, useState } from "react";

export const Countdown = ({ date, compact = false }) => {
  const [t, setT] = useState(calc(date));
  useEffect(() => {
    const i = setInterval(() => setT(calc(date)), 1000);
    return () => clearInterval(i);
  }, [date]);

  if (t.done) {
    return <span className="font-mono-label text-cyan-500">LIVE / PAST EVENT</span>;
  }
  const items = [
    { v: t.days, l: "Days" },
    { v: t.hours, l: "Hrs" },
    { v: t.mins, l: "Min" },
    { v: t.secs, l: "Sec" },
  ];
  return (
    <div className={`flex gap-2 ${compact ? "" : "gap-3"}`} data-testid="countdown-timer">
      {items.map((it) => (
        <div
          key={it.l}
          className={`flex flex-col items-center justify-center rounded-lg border border-cyan-500/30 bg-black/50 ${
            compact ? "h-12 w-12" : "h-16 w-16 sm:h-20 sm:w-20"
          }`}
        >
          <span className={`font-display font-black text-cyan-400 ${compact ? "text-lg" : "text-2xl sm:text-3xl"}`}>
            {String(it.v).padStart(2, "0")}
          </span>
          <span className="font-mono-label text-[9px] uppercase tracking-widest text-neutral-500">{it.l}</span>
        </div>
      ))}
    </div>
  );
};

function calc(date) {
  const diff = new Date(date).getTime() - Date.now();
  if (diff <= 0) return { done: true };
  return {
    done: false,
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    mins: Math.floor((diff / 60000) % 60),
    secs: Math.floor((diff / 1000) % 60),
  };
}
